import { createContext } from "react";

import { UserRoles } from "../api/resources/company/companyResourceStruct";

export type Company = {
  name: string;
  role: UserRoles[];
};

export interface AuthContext {
  userId: string | null;
  userCompanyId: string | null;
  userCompany: Company | null;
  hasAdminPrivilages: boolean;
  isLoading: boolean;

  signIn(param: { id: string }): void;
  signOut(): void;
}

export const authContext = createContext<AuthContext>({
  userId: null,
  userCompanyId: null,
  userCompany: null,
  hasAdminPrivilages: false,
  isLoading: true,

  signIn: notImplemented,
  signOut: notImplemented,
});

function notImplemented(): never {
  throw new Error("Missing AuthContextProvider");
}
